import type {
  IApiResponse,
  UserEligibleForMergeResponse,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const profileApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getIsEligibleForMerge: build.query<boolean, void>({
      query() {
        return {
          url: "/foundation/api/users/me/merge-eligible",
          method: "GET",
        };
      },
      transformResponse: (
        response: IApiResponse<UserEligibleForMergeResponse>
      ) => {
        return response.payload.data.is_eligible_for_merge;
      },
    }),
  }),
});
